import { render, staticRenderFns } from "./TiktokWrapper.vue?vue&type=template&id=9658096a&"
import script from "./TiktokWrapper.vue?vue&type=script&lang=js&"
export * from "./TiktokWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports